import { BaseResponse, TenantResolveResponse } from 'types';

import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

export const resolve = async (fullCode: string) =>
  apiLoaderInstance.get<BaseResponse<TenantResolveResponse>>(
    URL.RESOLVE_TENANT,
    {
      params: { fullCode },
      headers: { 'allow-not-found': true },
    }
  );
